import { render, staticRenderFns } from "./SchoolsEdit.vue?vue&type=template&id=74defc03&scoped=true&"
import script from "./SchoolsEdit.vue?vue&type=script&lang=js&"
export * from "./SchoolsEdit.vue?vue&type=script&lang=js&"
import style0 from "./SchoolsEdit.vue?vue&type=style&index=0&id=74defc03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74defc03",
  null
  
)

export default component.exports